import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl';
import API from '../../utils/API'
import constants from '../../utils/constants'
import { connect } from 'react-redux'

function GlobalPolicies(props) {
  const [passwordLength, setPasswordLength] = useState('');
  const [passwordPolicy, setPasswordPolicy] = useState(false);
  const [twoFactorAuth, setTwoFactorAuth] = useState(false);
  const [firstLogin, setFirstLogin] = useState(false);
  const [status, setStatus] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Global Policy IDs
  const policyID = constants.globalPolicies;

  useEffect(() => {
    getGlobalPolicies();
  }, [])

  /**
   * Get global policies and set state to reflect in global policy dropdown menu
   */
  function getGlobalPolicies() {
    API.getGlobalPolicies()
      .then(({ data }) => {
        let passwordSetting = data.find(setting => setting.global_policy_id === policyID.password);
        let twoFactorSetting = data.find(setting => setting.global_policy_id === policyID.twoFactorAuth);
        let firstLoginSetting = data.find(setting => setting.global_policy_id === policyID.firstLogin);
        // If setting exists then set to be active
        if(passwordSetting) {
          setPasswordPolicy(true);
          setPasswordLength(passwordSetting.settings.minimumLength);
        }
        if(firstLoginSetting) {
          setFirstLogin(true);
        }
        if(twoFactorSetting) setTwoFactorAuth(true)
      })
      .catch(err => {
        console.error(err.message);
      });
  }

  function handleDropdownClick(e) {
    e.stopPropagation();
    if(!dropdownOpen) {
      getGlobalPolicies();
    }
    document.getElementById("dropdown-menu").classList.toggle("show");
    setDropdownOpen(current => !current);
    setStatus('');
  }

  /**
   * Handle save button click to update global policies
   * @param {Event} e 
   */
  function handleSaveClick(e) {
    e.preventDefault();
    // Minimum length limited to double digit
    let passwordObj = {minimumLength: parseInt(passwordLength, 10)}

    // Update setting if active, delete if inactive
    if(passwordPolicy) {
      if(!passwordLength) {
        setStatus('MISSING_PASSWORD_MINI_LENGTH');
        return;
      }
      API.updateGlobalPolicy(policyID.password, passwordObj)
        .then(res => {
          setStatus('SUCCESS');
        }).catch(err => {
          // TODO: Handle empty password length field and set error message
          console.error(err);
          setStatus(err.message)
        })
    } else {
      API.deleteGlobalPolicy(policyID.password);
      setStatus('SUCCESS');
    }
    if(firstLogin){
      API.updateGlobalPolicy(policyID.firstLogin);
      setStatus('SUCCESS');
    } else {
      API.deleteGlobalPolicy(policyID.firstLogin);
      setStatus('SUCCESS');   
    }
    if(twoFactorAuth) {
      API.updateGlobalPolicy(policyID.twoFactorAuth);
      setStatus('SUCCESS');
    } else {
      API.deleteGlobalPolicy(policyID.twoFactorAuth);
      setStatus('SUCCESS');
    }
  }

  function handleChangePasswordLength(e) {
    e.preventDefault();
    setPasswordLength(e.target.value);
  }

  function handlePasswordLengthClick(e) {
    e.preventDefault();
    e.target.focus();
    e.target.select();
    return;
  }
  /**
   * Handle toggle of password switch
   */
  function togglePassword() {
    setPasswordPolicy(prevState => !prevState);
    setPasswordLength('');
  }

  /**
   * Handle toggle of 2FA switch
   */
  function toggle2FA() {
    setTwoFactorAuth(prevState => !prevState);
  }

  /**
   * Toggle firstLogin
   */
  function toggleFirstLogin() {
    setFirstLogin(prevState => !prevState);
  }

  return (
    <div className="dropdown">
      <button onClick={handleDropdownClick} type="button" className="btn btn-primary dropdown-toggle" aria-expanded="false">
        <FormattedMessage id="GLOBAL_POLICIES" />
      </button>
      <div className="dropdown-menu" id="dropdown-menu" aria-labelledby="dropdownMenuButton1">
        <form className="px-5 py-3">
          <div className="mb-3 row form-group">
            <div className="mb-2 form-check">
              <input
                className="form-check-input" 
                type="checkbox" 
                value="" 
                id="passwordCheck" 
                checked={passwordPolicy} 
                onChange={(e) => togglePassword(e)}  
              />
              <label className="form-check-label" htmlFor="passwordCheck">
                <FormattedMessage id="PASSWORD" />
              </label>
            </div>
            <div className={"collapse row " + (passwordPolicy ? "show" : "")} id="passwordCollapse">
              <label htmlFor="passwordLength" className="col-8 dropdown-item-text"><FormattedMessage id="MINIMUM_LENGTH" /><FormattedMessage id="SYMBOL_COLON" /></label>
              <div className="col-4">
                <input 
                  className="form-control" 
                  id="dropdownPasswordLength" 
                  type="text"
                  pattern="^[0-9]{1,2}$"
                  maxLength="2"
                  value={passwordLength} 
                  onClick={(e)=> handlePasswordLengthClick(e)} 
                  onChange={(e) => handleChangePasswordLength(e)} 
                />
              </div>
            </div>
          </div>
          <div className="mb-3 row">
            <div className="form-check">
              <input onChange={(e)=>toggleFirstLogin(e)} className="form-check-input" type="checkbox" value="" id="twoFactorCheck" checked={firstLogin}/>
              <label className="form-check-label" htmlFor="twoFactorCheck">
                <FormattedMessage id="REQ_PASSWORD_CHANGE" />
              </label>
            </div>
          </div>
          <div className="mb-3 row">
            <div className="form-check">
              <input onChange={(e) => toggle2FA(e)} className="form-check-input" type="checkbox" value="" id="twoFactorCheck" checked={twoFactorAuth}/>
              <label className="form-check-label" htmlFor="twoFactorCheck">
                <FormattedMessage id="SAVE_1" />(Not Implemented Yet)
              </label>
            </div>
          </div>
          <div className="row justify-content-center">
            <button onClick={(e) => handleSaveClick(e)} type="submit" className="btn save-btn"><FormattedMessage id="SAVE" /></button>
            {status ? <p className='status mt-2 mb-0'>{status}</p> : null}
          </div>
        </form>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(GlobalPolicies)